module.exports = __webpack_public_path__ + "img/fav-dark.877d320c.png";